module.exports = __webpack_public_path__ + "img/dojan.6ba0ffd7.png";